import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

export const mock = [
  {
    title: 'Solicitud',
    location: 'Madrid',
    type: 'Remote',
    link: '/transparencia'
  },
  {
    title: 'Certificado de Transparencia',
    location: 'Paris',
    type: 'Full time',
    link: '/transparencia'
  },
  {
    title: 'Presupuesto',
    location: 'Yerevan',
    type: 'Part time',
    link: '/transparencia'

  },

  {
    title: 'Transparencia Inai',
    location: 'Madrid',
    type: 'Remote',
    link: '/transparencia'
  },
  {
    title: 'Informacion Publica',
    location: 'Paris',
    type: 'Full time',
    link: '/transparencia'
  },
  {
    title: 'Transparencia Nacional',
    location: 'Yerevan',
    type: 'Part time',
    link: '/transparencia'
  },
];

const Jobs = ({acuerdos}) => {
  return (
    <Box>
      <Box marginBottom={4}>
        <Typography
          variant={'h4'}
          gutterBottom
          align={'center'}
          sx={{ fontWeight: 700 }}
        >
          Presupuesto 2022 2024
        </Typography>
        <Typography
          variant={'h6'}
          component={'p'}
          color={'text.secondary'}
          align={'center'}
        >
          Descarga los acuerdos munipales
          <br />

        </Typography>
        <Box marginTop={3} display={'flex'} justifyContent={'center'}>

        </Box>
      </Box>
      <Grid container spacing={2}>
        {acuerdos && Object.keys(acuerdos).map((key, i) => (

            <Grid item xs={12} key={i}>
            <Box
              component={Card}
              variant={'outlined'}
              bgcolor={'transparent'}
              sx={{
                '&:hover': {
                  boxShadow: 2,
                },
              }}
            >
              <Box
                component={CardContent}
                display={'flex'}
                alignItems={'center'}
              >
                <Box
                  display={'flex'}
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  flex={'1 1 100%'}
                  justifyContent={{ sm: 'space-between' }}
                  alignItems={{ sm: 'center' }}
                >
                  <Typography
                    variant={'h6'}
                    fontWeight={700}
                    sx={{ marginBottom: { xs: 1, sm: 0 } }}
                  >
                    {acuerdos[key].title}
                  </Typography>
                  <Typography variant={'subtitle1'} color={'text.secondary'}>

                  </Typography>
                </Box>
                <Box marginLeft={2} color={'primary.main'}>

                  <Button
                      width={{ xs: 30, sm: 40 }}
                      fill="currentColor"
                      height={{ xs: 10, sm: 20 }}
                      sx={{ cursor: 'pointer' }}
                      variant="contained"
                      color="primary"
                      href={`${acuerdos[key].document} `}
                      size="large"
                      endIcon={
                        <svg
                            width={16}
                            height={16}
                            xmlns="http://www.w3.org/2000/svg"
                            fill="none"
                            viewBox="0 0 24 24"
                            stroke="currentColor"
                        >
                          <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth={2}
                              d="M17 8l4 4m0 0l-4 4m4-4H3"
                          />
                        </svg>
                      }
                  >
                    Descargar
                  </Button>


                </Box>
              </Box>
            </Box>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export default Jobs;
